import { inject, Injectable, Signal } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import type {
  DialogApi,
  CreateDialogArgs,
} from './download-charts-pdf-dialog.types';
import { DownloadChartsPdfDialogComponent } from './download-charts-pdf-dialog.component';
import type { KpiChart } from '../download-charts-pdf.types';
import { ChartsService } from '../../charts-service';

@Injectable({ providedIn: 'root' })
export class DownloadChartsPdfDialogService {
  private readonly matDialog = inject(MatDialog);

  openDialog(args: CreateDialogArgs): DialogApi {
    const dialogData = {
      displayCharts: this.extractChartsMatrix(args.chartsService),
      containerId: `ops-container-${crypto.randomUUID()}`,
    };

    const modalRef = this.matDialog.open<DownloadChartsPdfDialogComponent>(
      DownloadChartsPdfDialogComponent,
      {
        width: '1200px',
        maxWidth: '1200px',
        hasBackdrop: false,
        data: dialogData,
      },
    );

    return {
      dispose: () => modalRef.close(),
      get htmlElement() {
        return document.getElementById(dialogData.containerId);
      },
    };
  }

  private extractChartsMatrix(
    chartsService: ChartsService,
  ): Signal<KpiChart>[][] {
    return [
      [
        chartsService.mttrAllNOCCasesLife.signal,
        chartsService.yearNitelNps.signal,
        chartsService.csatSurveyResults.signal,
      ],
      [
        chartsService.activeServices.signal,
        chartsService.inflightOrders.signal,
        chartsService.newClosedCases.signal,
      ],
      [
        chartsService.closedCases.signal,
        chartsService.oldOpenCareCases.signal,
        chartsService.openCareCases.signal,
      ],
      [
        chartsService.oldOpenNOCCases.signal,
        chartsService.openNOCCases.signal,
        chartsService.oldOpenSupportCases.signal,
      ],
      [
        chartsService.openSuportCases.signal,
        chartsService.oldOpenFinanceCases.signal,
        chartsService.openFinanceCases.signal,
      ],
      [
        chartsService.emergencyCases.signal,
        chartsService.openMaintenanceCases.signal,
      ],
      [chartsService.caseHistoryByDate.signal],
      [chartsService.ytdNocCasesClosedCode.signal],
      [chartsService.mttrCircuitDown.signal],
    ];
  }
}
